<template>
    <content class="content" menu="支撑材料" :childmenus="childmenus" :menuIndex="menuIndex" @childMenuChange = "childMenuChange" 
    :location = "location"> 
        <chapter_list class="chapter_list" :datas="datas"  v-if="isShowChapterList"></chapter_list>	
        <image_list v-else :path = "path" :count="count"></image_list>
    </content>
</template>

<script>
    import content from './content.vue'
    import chapter_list from "../exhibition/chapter_list.vue"
    import image_list from '../exhibition/image_list.vue'
    const cityData = require('../../assets/data/support_materials.json')
    export default {
        name:"ApplicationForm",
        components:{
            content,
            chapter_list,
            image_list
        },
        props:{
        },
        data() {
            return {
                childmenus:[
				{
					name:"同行评价",
                    datas:[
                        {name:'云南艺术学院',url:'/support_materials',id:'60000'},
                        {name:'广西艺术学院',url:'/support_materials',id:'60001'},
                        {name:'吉林艺术学院',url:'/support_materials',id:'60002'}
                    ]
				},
				{
					name:"一流专业建设体系" ,
                    datas:[
                        {name:'国家级一流专业建设点',url:'/support_materials',id:'60100'},
                        {name:'自治区级教学成果',url:'/support_materials',id:'60101'},
                        {name:'自治区级一流本科课程',url:'/support_materials',id:'60102'}
                    ]
				},
				{
					name:"政校企协同育人建设",
                    datas:[
                        {name:'“产学研育人”校企合作一览表及协议书',url:'/support_materials',id:'60200'},
                        {name:'校企合作“双育人”模式企业鉴定表',url:'/support_materials',id:'60201'},
                        {name:'布丝瑰研学基地项目优秀成果展示',url:'/support_materials',id:'60202'}
                    ]
				},
				{
					name:"教育教学理论成果",
                    datas:[
                        {name:'教研教改项目',url:'/support_materials',id:'60300'},
                        {name:'教学教研论文',url:'/support_materials',id:'60301'},
                        {name:'教材、专著',url:'/support_materials',id:'60302'},
                        {name:'专利获批',url:'/support_materials',id:'60303'}
                    ]
				}],
                datas:[],
                isShowChapterList:true,
                path:'awards_condition/01/',
                count:16,
                menuIndex:0,
                location:['支撑材料'],
            };
        },
        methods:{
            childMenuChange(index){
                this.isShowChapterList  =true;
                this.datas = this.childmenus[index].datas;
                this.$router.push({ query: { } })

                this.location = [];
				this.location.push('支撑材料');
				this.location.push(this.childmenus[index].name);
            }
        },
        created() {
            this.datas = this.childmenus[0].datas;
            var id =  this.$route.query.id;
           
            if(id === undefined){
                this.isShowChapterList =true;
                return;
            }

            this.isShowChapterList =false;
            let queryData = cityData.filter(function(data){
                return data.id == id;
            })
            this.path = queryData[0].path;
            this.count = queryData[0].count;

            let menuIndex = id.slice(1,3);
            this.menuIndex = menuIndex;

            this.location = [];
            this.location.push('支撑材料');
            let menuName = this.childmenus[Number(menuIndex)].name;
            this.location.push(menuName);
            let nameIndex =Number(id.slice(3,5));

            let name = this.childmenus[Number(menuIndex)].datas[nameIndex].name;
            this.location.push(name);
        }
    }
</script>

<style lang="scss" scoped>
    .chapter_list{
        height: calc(100vh - 360px);
    }
</style>

